import { Injectable } from '@angular/core';
import { UpgradeScheduleDraft } from '../../support.interface';
import { CaseDraftService } from './case-draft.service';

@Injectable()
export class UpgradeCaseDraftService extends CaseDraftService<UpgradeScheduleDraft> {
    protected DRAFT_KEY = 'upgrade_case_draft';
}
